<template>
  <div class="data">
    <AmInput
      v-model="stepsData.identify.fullName"
      :test-name="'full_name'"
      class="input--custom data__name"
      :label="$t('steps.data.fullName.label')"
      :placeholder="$t('steps.data.fullName.placeholder')"
      :validity-state="statusFullNameValidate"
      :secondary-label="textFullNameValidate"
      @focusout.native="validateFullName"
    />
    <AmInput
      v-if="showWhenInternational"
      v-model="stepsData.identify.document"
      :test-name="'document'"
      class="input--custom"
      :label="$t('steps.data.document.label')"
      :placeholder="$t('steps.data.document.placeholder')"
      input-mode="text"
      :validity-state="statusDocumentValidate"
      :secondary-label="textDocumentValidate"
      @focusout.native="validateDocumentOnBlur"
    />
    <AmPhoneNumber
      v-if="showWhenInternational"
      v-model="stepsData.identify.internationalTelephone"
      :hint="textTelephoneValidate"
      :label="$t('steps.data.telephone.label')"
      :default-country-code="countryCode"
      :error="isInternationalPhoneInvalid"
      :phone-number-label="$t('steps.data.telephone.numberLabel')"
      @update="updatePhoneNumber"
      @blur="blurInternacionalPhone"
    />
    <AmInputMask
      v-else
      v-model="stepsData.identify.brazilianTelephone"
      typeMask="fixed"
      :mask="['(##) #####-####', '(##) ####-####']"
      data-test="whatsapp"
      class="input--custom"
      :label="$t('steps.data.whatsapp.label')"
      :placeholder="$t('steps.data.whatsapp.placeholder')"
      :validity-state="statusWhatsappValidate"
      :secondary-label="textWhatsappValidate"
      input-mode="tel"
      @focusout.native="validateWhatsapp"
    />
    <AmInput
      v-model="stepsData.identify.email"
      :test-name="'email'"
      class="input--custom"
      :label="$t('steps.data.email.label', { textOptional: isRequiredEmail ? '' : '(Opcional)' })"
      type="email"
      :placeholder="$t('steps.data.email.placeholder')"
      :validity-state="statusEmailValidate"
      :secondary-label="textEmailValidate"
      @focusout.native="validateEmail"
    />
    <form data-appmax-customer />
  </div>
</template>

<script>
import AmPhoneNumber from '@/components/molecules/AmPhoneNumber.vue'
import replaceSpecialCharactersMixin from '@/components/mixins/replaceSpecialCharactersMixin'
import countryMixin from '@/components/mixins/countryMixin'
import queryPersistance from '@/components/mixins/queryPersistance'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'StepData',
  components: {
    AmPhoneNumber,
  },
  mixins: [replaceSpecialCharactersMixin, countryMixin, queryPersistance],
  data() {
    return {
      stepsData: {
        identify: {
          fullName: null,
          email: null,
          countryCode: null,
          internationalTelephone: null,
          brazilianTelephone: null,
          telephone: null,
          document: null,
        },
      },
      isInternationalPhoneInvalid: false,
      statusFullNameValidate: null,
      statusDocumentValidate: null,
      textFullNameValidate: '',
      textDocumentValidate: null,
      statusWhatsappValidate: null,
      textWhatsappValidate: '',
      textTelephoneValidate: '',
      statusEmailValidate: null,
      textEmailValidate: '',
      customerIP: null,
    }
  },
  computed: {
    ...mapState('Checkout', {
      isRequiredEmail: (state) => state.cart.settings?.email_required,
      identity: (state) => state.cart?.customer,
      cart: (state) => state.cart,
    }),
    ...mapGetters('Cart', ['getCurrencyCode', 'isInfoProduto', 'getIsInternational'], {
      enableAddress: 'getEnableAddress',
    }),
    ...mapGetters('Customer', {
      customer: 'getCustomer',
    }),
    countryCode() {
      const { country_code } = this.customer
      return country_code || this.mapperCurrencyCodeToCountryCode[this.getCurrencyCode]
    },
    showWhenInternational() {
      return this.isInfoProduto && this.getIsInternational
    },
  },
  watch: {
    cart: {
      immediate: true,
      deep: true,
      async handler() {
        this.handleLoadCustomer()
      },
    },
  },
  mounted() {
    this.SET_CURRENT_STEP(0)
    const script = document.createElement('script')
    script.src = 'https://scripts.appmax.com.br/appmax.min.js'
    script.async = true

    script.onload = () => {
      if (window.AppCheckout) {
        window.AppCheckout.init(this.successFingerPrint, this.errorFingerPrint)
      } else {
        // eslint-disable-next-line no-console
        console.log('AppCheckout não carregado.')
      }
    }

    script.onerror = () => {
      // eslint-disable-next-line no-console
      console.log('Erro ao carregar o script.')
    }

    document.head.appendChild(script)
  },
  methods: {
    ...mapActions('Checkout', [
      'shipping',
      'fetchCep',
      'paymentBillet',
      'paymentCreditCard',
      'paymentPix',
      'states',
      'createOrder',
      'fetchCart',
    ]),
    ...mapActions('Customer', ['identify']),
    ...mapMutations('Checkout', ['SET_CURRENT_STEP']),
    successFingerPrint(response) {
      this.customerIP = response.ip
    },
    errorFingerPrint(responseError) {
      // eslint-disable-next-line no-console
      console.log(responseError)
    },
    handleLoadCustomer() {
      if (!this.customer.full_name) {
        return
      }

      let { email } = this.customer

      if (email && !this.cart.settings.email_required) {
        email = email.slice(email.indexOf('@')).includes('appmax') ? '' : email
      }

      this.customer.email = email

      if (this.showWhenInternational) {
        this.stepsData.identify = this.getInternationalCustomer(this.customer)
        return
      }

      this.stepsData.identify = this.getNationalCustomer(this.customer)
    },
    getInternationalCustomer(customer) {
      const {
        full_name: fullName,
        telephone,
        national_number: nationalNumber,
        email,
        country_code: countryCode,
        document_number,
      } = customer
      return {
        fullName,
        telephone,
        email,
        brazilianTelephone: telephone,
        internationalTelephone: nationalNumber,
        document: document_number,
        countryCode,
      }
    },
    getNationalCustomer(customer) {
      const {
        full_name: fullName,
        telephone,
        national_number: nationalNumber,
        email,
        country_code: countryCode,
        document: document_number,
      } = customer
      return {
        fullName,
        telephone,
        email,
        brazilianTelephone: telephone,
        internationalTelephone: nationalNumber,
        countryCode,
        document_number,
      }
    },
    getPayloadInternationalCustomer(identify) {
      const { email, document, fullName, countryCode, telephone, internationalTelephone } = identify
      const telephoneWithoutMask = this.replaceSpecialCharacters(telephone)
      const documentWithoutMask = this.removeSpecialCharaters(document)
      const internationalTelephoneWithoutMask =
        this.replaceSpecialCharacters(internationalTelephone)

      return {
        full_name: fullName,
        email,
        telephone: telephoneWithoutMask,
        country_code: countryCode,
        national_number: internationalTelephoneWithoutMask || '',
        document_number: documentWithoutMask,
      }
    },
    getPayloadNationalCustomer(identify) {
      const brazilianTelephone = this.replaceSpecialCharacters(identify.brazilianTelephone)
      const { email, fullName } = identify
      return {
        full_name: fullName,
        email,
        telephone: brazilianTelephone || '',
        ip: this.customerIP,
      }
    },
    async nextStep() {
      return new Promise((resolve, reject) => {
        const validate = this.validateData()
        const { email } = this.stepsData.identify
        let dataIdentify

        if (validate) {
          if (!email) {
            delete this.stepsData.identify.email
          }
          if (this.showWhenInternational) {
            dataIdentify = this.getPayloadInternationalCustomer(this.stepsData.identify)
          } else {
            dataIdentify = this.getPayloadNationalCustomer(this.stepsData.identify)
          }

          this.identify(dataIdentify)
            .then(() => {
              this.redirectToNextStep()
              resolve()
            })
            .catch((e) => reject(e))
        } else {
          reject()
        }
      })
    },
    redirectToNextStep() {
      let routeName
      if (this.getIsInternational) {
        routeName = 'new.stepPayment-card'
        this.$router.push({
          name: routeName,
          params: { history: true },
          query: { pl: this.getPl?.pl },
        })
        return
      }
      routeName = this.isInfoProduto
        ? 'new.stepPayment'
        : this.$route?.params?.newRoute || 'new.stepAddress'

      this.$router.push({
        name: routeName,
        params: { history: true },
        query: { pl: this.getPl?.pl },
      })
    },
    validateData() {
      const validName = this.validateFullName()
      const validEmail = this.validateEmail()

      if (this.isInfoProduto && this.getIsInternational) {
        const validDocument = this.validateDocument()
        const validTelephone = !this.validateInternationalTelephone()
        return validName && validEmail && validDocument && validTelephone
      }
      const validWhatsapp = this.validateWhatsapp()
      return validName && validEmail && validWhatsapp
    },
    validateFullName() {
      if (!this.stepsData.identify.fullName) {
        this.statusFullNameValidate = 'error'
        this.textFullNameValidate = this.$t('steps.validators.required')
        return false
      }

      const splitName = this.stepsData.identify.fullName.split(' ')
      const lastNameExists = splitName[1]?.length

      if (!lastNameExists) {
        this.statusFullNameValidate = 'error'
        this.textFullNameValidate = this.$t('steps.validators.invalid.name.andLast')
        return false
      }

      this.statusFullNameValidate = 'success'
      this.textFullNameValidate = ''

      return true
    },
    isDocumentValid() {
      return !this.stepsData.identify.document || this.stepsData.identify.document.length < 5
    },
    setDocumentValidations({ status, text }) {
      this.statusDocumentValidate = status
      this.textDocumentValidate = text
    },
    validateDocumentOnBlur() {
      if (this.isDocumentValid()) {
        this.setDocumentValidations({ status: 'error', text: this.$t('steps.validators.required') })
        return
      }
      this.setDocumentValidations({ status: 'success', text: '' })
    },
    validateDocument() {
      if (this.isDocumentValid()) {
        this.setDocumentValidations({ status: 'error', text: this.$t('steps.validators.required') })
        return false
      }
      return true
    },
    validateWhatsapp() {
      if (!this.stepsData.identify.brazilianTelephone) {
        this.statusWhatsappValidate = 'error'
        this.textWhatsappValidate = this.$t('steps.validators.required')
        return false
      }

      const replacePhone = this.replaceSpecialCharacters(this.stepsData.identify.brazilianTelephone)
      if (replacePhone.length < 10) {
        this.statusWhatsappValidate = 'error'
        this.textWhatsappValidate = this.$t('steps.validators.invalid.phone')
        return false
      }

      this.statusWhatsappValidate = 'success'
      this.textWhatsappValidate = ''

      return true
    },
    validateEmail() {
      if (this.isRequiredEmail) {
        if (!this.stepsData.identify.email) {
          this.statusEmailValidate = 'error'
          this.textEmailValidate = this.$t('steps.validators.required')
          return false
        }
      }

      const emailRule = /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/g
      const validEmail = emailRule.test(this.stepsData.identify.email)
      if (this.stepsData.identify.email) {
        if (!validEmail) {
          this.statusEmailValidate = 'error'
          this.textEmailValidate = this.$t('steps.validators.invalid.email')
          return false
        }
      }

      this.statusEmailValidate = 'success'
      this.textEmailValidate = ''

      return true
    },
    blurInternacionalPhone() {
      this.invalidateEmptyInternacionalTelephone()
    },
    checkInternationalPhone(payload) {
      this.invalidateEmptyInternacionalTelephone()

      this.isInternationalPhoneInvalid = !payload.isValid

      if (this.isInternationalPhoneInvalid) {
        this.textTelephoneValidate = this.$t('steps.validators.invalid.phone')
      } else {
        this.textTelephoneValidate = ''
      }
    },
    invalidateEmptyInternacionalTelephone() {
      if (!this.stepsData.identify.telephone) {
        this.isInternationalPhoneInvalid = true
        this.textTelephoneValidate = this.$t('steps.validators.required')
      }
    },
    setRequiredErrorOnInternationalPhone() {
      if (this.stepsData.identify.internationalTelephone) {
        return
      }
      this.textTelephoneValidate = this.$t('steps.validators.required')
      this.isInternationalPhoneInvalid = true
    },
    getCodeCountry(payload) {
      this.stepsData.identify.countryCode = payload.countryCode
    },
    getCompleteTelephone(payload) {
      if (!payload.formattedNumber) {
        return
      }
      this.stepsData.identify.telephone = payload.formattedNumber.slice(1)
    },
    updatePhoneNumber(payload) {
      this.getCodeCountry(payload)
      this.getCompleteTelephone(payload)
      this.checkInternationalPhone(payload)
    },
    validateInternationalTelephone() {
      this.setRequiredErrorOnInternationalPhone()
      return this.isInternationalPhoneInvalid
    },
  },
}
</script>
<style lang="scss" scoped>
.data {
  &__name {
    margin-top: 0;
  }
}
</style>
